import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { LOGIN_URL } from 'cons/routes';

const ValidatorRoute = memo(
  ({ children, validators, redirectionPath = LOGIN_URL }) => {
    // Create a memoized selector that computes validation result
    // This avoids selecting the entire state which causes unnecessary re-renders
    const validatorSelector = useMemo(
      () =>
        validators && validators.length > 0
          ? (state) => validators.map((v) => v(state)).every((i) => !!i)
          : () => true,
      [validators]
    );
    const validatorsSatisfied = useSelector(validatorSelector);

    if (!validatorsSatisfied) {
      return <Navigate to={redirectionPath} replace />;
    }

    return children;
  }
);

export default ValidatorRoute;
